<template>
  <div class="content-page">
    <div class="content-page__title">
      <slot v-if="$slots && $slots.header"
            name="header"></slot>
      <template v-else>
        <h2 class="content-page__title--white">{{ title }}</h2>
        <slot name="title-after" class="content-page__title__after"></slot>
      </template>
    </div>
    <div v-if="loading" class="content-page__loading">
      <loading-icon />
    </div>
    <div v-else class="content-page__body">
      <slot />
    </div>
  </div>
</template>

<script>
import LoadingIcon from '@/utils/components/LoadingIcon.vue';

export default {
  name: 'contentPage',
  components: {
    LoadingIcon,
  },
  props: {
    loading: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.content-page {
  min-height: Min(calc(100vh - 80px), 600px);
  margin: 0 0 40px;
  @include breakpoint(tablet) {
    margin: 0 20px 40px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin 40px;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin 40px;
  }
  &__title {
    display: block;
    margin-top: 20px;
    margin-left: 20px;
    @include breakpoint(tablet) {
      display: flex;
      margin-left: 0;
    }
    &--white {
      flex: 1;
      color: $--color-white;
    }
    &__after {
      //
    }
  }
  &__loading {
    margin-top: 4em;
    text-align: center;
  }
  @include breakpoint(tablet) {
    &__body {
      padding-bottom: 20px;
    }
  }
}
</style>
